/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type BillectaSyncTarget = {
  id: string;
  target: BillectaSyncTarget.target;
} | {
  productId: string;
  siteId: string;
  target: BillectaSyncTarget.target;
};
export namespace BillectaSyncTarget {
  export enum target {
    DEBTOR = "debtor",
  }
}
